var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgKmallLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 110,
    height: 33,
    viewBox: "0 0 110 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_651_6192)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M16.3725 33H33.0508V24.1668L15.0077 16.6714V16.3286L33.0508 8.83317V0H16.3725V6.94271H21.9083V7.19146L8.17807 12.6528V0H0V33H8.17807V20.3528L21.81 25.8085V26.0518H16.3725V33Z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.9082 6.94263H33.0507V8.83308L21.9082 7.19137",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.8154 26.0407H33.0507V24.1558L21.8154 25.7975",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M46.4424 23.8463V8.99902H47.7799V16.992H47.9109L55.0681 8.99902H56.8315L50.5696 15.8644L56.8042 23.8463H55.1718L49.7398 16.8096L47.7854 19.0262V23.8463H46.4478H46.4424Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.3482 8.99902H60.8932L66.2106 21.9282H66.3416L71.659 8.99902H73.204V23.8463H71.9429V11.8623H71.8283L66.8821 23.8463H65.6647L60.7185 11.8623H60.6039V23.8463H59.3428V8.99902H59.3482Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M77.1238 23.8463H75.7207L81.0545 8.99902H82.4848L87.8186 23.8463H86.4155L81.8188 10.7623H81.7205L77.1238 23.8463ZM78.1337 18.1583H85.4056V19.3744H78.1337V18.1583Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90.3301 23.8463V8.99902H91.6676V22.6247H98.6556V23.8407H90.3301V23.8463Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.674 23.8463V8.99902H103.012V22.6247H110V23.8407H101.674V23.8463Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_651_6192",
    x1: 33.0508,
    y1: 16.5,
    x2: 0,
    y2: 16.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_651_6192",
    x1: 27.5968,
    y1: 7.02001,
    x2: 27.3786,
    y2: 8.61678,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_651_6192",
    x1: 27.5477,
    y1: 25.9744,
    x2: 27.3295,
    y2: 24.3776,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopOpacity: 0.54
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.52,
    stopColor: "#fff",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_651_6192"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 110,
    height: 33,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgKmallLogo);
export default __webpack_public_path__ + "static/media/kmallLogo.4ae068b799edd99ad9f58b2f4eadf2a9.svg";
export { ForwardRef as ReactComponent };